// extracted by mini-css-extract-plugin
export default {"Card":"DashboardCard_Card__pVMEO","cardText":"DashboardCard_cardText__tP4ry","profileImage":"DashboardCard_profileImage__RO0gD","iconCard":"DashboardCard_iconCard__Ln3dx"};